"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.markdownSchemaValidator = exports.variableDefinitionValidator = exports.userVariableDefinition = exports.userVariableValidator = exports.tabVariableDefinition = exports.tabVariableValidator = exports.MarkdownVariableSummarization = void 0;
const zod_1 = require("zod");
var MarkdownVariableSummarization;
(function (MarkdownVariableSummarization) {
    MarkdownVariableSummarization["SUM"] = "SUM";
    MarkdownVariableSummarization["AVG"] = "AVG";
    MarkdownVariableSummarization["COUNT"] = "COUNT";
    MarkdownVariableSummarization["MIN"] = "MIN";
    MarkdownVariableSummarization["MAX"] = "MAX";
    MarkdownVariableSummarization["COUNT_DISTINCT"] = "COUNT_DISTINCT";
})(MarkdownVariableSummarization = exports.MarkdownVariableSummarization || (exports.MarkdownVariableSummarization = {}));
exports.tabVariableValidator = zod_1.z.object({
    id: zod_1.z.string(),
    summarization: zod_1.z.nativeEnum(MarkdownVariableSummarization),
    column_id: zod_1.z.string(),
});
exports.tabVariableDefinition = zod_1.z.object({
    type: zod_1.z.literal('tab'),
    tab_id: zod_1.z.number(),
    creditor_column_id: zod_1.z.string(),
    variables: zod_1.z.array(exports.tabVariableValidator),
});
exports.userVariableValidator = zod_1.z.object({
    id: zod_1.z.string(),
    user_field: zod_1.z.union([zod_1.z.literal('email'), zod_1.z.literal('name'), zod_1.z.literal('teams')]),
});
exports.userVariableDefinition = zod_1.z.object({
    type: zod_1.z.literal('user'),
    variables: zod_1.z.array(exports.userVariableValidator),
});
exports.variableDefinitionValidator = zod_1.z.discriminatedUnion('type', [
    exports.userVariableDefinition,
    exports.tabVariableDefinition,
]);
const FilePayload = zod_1.z.object({
    fileId: zod_1.z.string(),
    filename: zod_1.z.string(),
});
exports.markdownSchemaValidator = zod_1.z.object({
    value: zod_1.z.string(),
    availableImages: zod_1.z.array(FilePayload),
    variables_definition: zod_1.z.array(exports.variableDefinitionValidator).optional(),
});
